<template>
<div class="detail create">
    <div class="screen">
        <div class="banner">
            <mt-field readonly label="表单编号" v-model="detail.businessKey"></mt-field>
        </div>
    </div>
    <div class="center">
        <applicant-info :editable="false" :costName="displayCostCenter" :lineName="detail.businessLineName" :applicant="detail.applicantName" :createUserName="detail.submiterName" :createDate="detail.applicationDateStr"></applicant-info>
        <!-- <applicant-info :editable="true" :value="request"></applicant-info> -->
        <div v-if="detail.currentRole == 100 || detail.currentRole == 2 || detail.currentRole == 3 || detail.currentRole==10" class="a_infor" :class="{open:isOpen}">
            <p @click="isOpen=!isOpen">{{title}}</p>
            <div class="box">
                <mt-radio v-if="detail.currentRole!='10'"  title="协议类型：" v-model="request.protocolType" :options="TypeOptions"></mt-radio>
                <mt-field  readonly v-else label="协议类型："  v-model="detail.protocolTypeStr" ></mt-field>
                <mt-radio v-if="detail.currentRole!='10'" title="签订类型：" v-model="request.signType" :options="SignedOptions"></mt-radio>
                <mt-field readonly v-else label="签订类型："  v-model="detail.signTypeStr" ></mt-field>
                <a class="mint-cell mint-field choose">
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title">
                            <span class="mint-cell-text">年度</span>
                        </div>
                        <div class="mint-cell-value" @click="showFiscalYearPup">
                            <mt-field readonly v-model="fiscalYearName" ></mt-field>
                        </div>
                    </div>
                    <mt-popup v-model="popupFiscalYearVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%">
                        <mt-picker :slots="fiscalYearList" value-key="label" @change="onFiscalYearValuesChange" style="width: 100%" showToolbar>
                            <div class="picker-toolbar-title">
                                <div class="mint-datetime-action mint-datetime-cancel" @click="popupFiscalYearVisible = !popupFiscalYearVisible">
                                    关闭
                                </div>
                                <div class="mint-datetime-action mint-datetime-confirm" @click="confirmFiscalYearSelect">
                                    确定
                                </div>
                            </div>
                        </mt-picker>
                    </mt-popup>
                </a>
                <!-- <a class="mint-cell mint-field choose">
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title">
                            <span class="mint-cell-text">区域</span>
                        </div>
                        <div class="mint-cell-value" @click="showDistrictPup">
                            <mt-field readonly v-model="districtName" ></mt-field>
                        </div>
                    </div>
                    <mt-popup v-model="popupDistrictVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%">
                        <mt-picker :slots="districtList" value-key="label" @change="onDistrictValuesChange" style="width: 100%" showToolbar>
                            <div class="picker-toolbar-title">
                                <div class="mint-datetime-action mint-datetime-cancel" @click="popupDistrictVisible = !popupDistrictVisible">
                                    关闭
                                </div>
                                <div class="mint-datetime-action mint-datetime-confirm" @click="confirmDistrictSelect">
                                    确定
                                </div>
                            </div>
                        </mt-picker>
                    </mt-popup>
                </a> -->
                <mt-checklist title="服务类型" v-model="serviceTypeCheckList" :options="serviceTypeOptions"></mt-checklist>
                <mt-field v-if="serviceTypeCheckOther" label="其他服务类型" placeholder="请输入其他服务类型" v-model="serviceTypeOtherDesc"></mt-field>
                <a v-if="!(request.protocolType=='20'&&request.signType=='10')" class="mint-cell mint-field choose">
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title">
                            <span class="mint-cell-text">增长类型</span>
                        </div>
                        <div class="mint-cell-value" @click="showIncrementPup">
                            <mt-field readonly v-model="incrementName" ></mt-field>
                        </div>
                    </div>
                    <mt-popup v-model="incrementPopupVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%">
                        <mt-picker :slots="incrementList" value-key="className" @change="onIncrementValuesChange" style="width: 100%" showToolbar>
                            <div class="picker-toolbar-title">
                                <div class="mint-datetime-action mint-datetime-cancel" @click="incrementPopupVisible = !incrementPopupVisible">
                                    关闭
                                </div>
                                <div class="mint-datetime-action mint-datetime-confirm" @click="confirmIncrementSelect">
                                    确定
                                </div>
                            </div>
                        </mt-picker>
                    </mt-popup>
                </a>
                <a v-if="!(request.protocolType=='20'&&request.signType=='10')" class="mint-cell mint-field choose">
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title">
                            <span class="mint-cell-text">减少类型</span>
                        </div>
                        <div class="mint-cell-value" @click="showDecrementPup">
                            <mt-field readonly v-model="decrementName" ></mt-field>
                        </div>
                    </div>
                    <mt-popup v-model="decrementVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%">
                        <mt-picker :slots="decrementList" value-key="className" @change="onDecrementValuesChange" style="width: 100%" showToolbar>
                            <div class="picker-toolbar-title">
                                <div class="mint-datetime-action mint-datetime-cancel" @click="decrementVisible = !decrementVisible">
                                    关闭
                                </div>
                                <div class="mint-datetime-action mint-datetime-confirm" @click="DecrementconfirmSelect">
                                    确定
                                </div>
                            </div>
                        </mt-picker>
                    </mt-popup>
                </a>
                <a class="mint-cell mint-field choose">
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title">
                            <span class="mint-cell-text">用章申请</span>
                        </div>
                        <div class="mint-cell-value" @click="showSealTypePup">
                            <mt-field readonly v-model="sealTypeName" ></mt-field>
                        </div>
                    </div>
                    <mt-popup v-model="popupSealTypeVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%">
                        <mt-picker :slots="sealTypeList" value-key="label" @change="onSealTypeValuesChange" style="width: 100%" showToolbar>
                            <div class="picker-toolbar-title">
                                <div class="mint-datetime-action mint-datetime-cancel" @click="popupSealTypeVisible = !popupSealTypeVisible">
                                    关闭
                                </div>
                                <div class="mint-datetime-action mint-datetime-confirm" @click="confirmSealTypeSelect">
                                    确定
                                </div>
                            </div>
                        </mt-picker>
                    </mt-popup>
                </a>
                <a class="mint-cell mint-field choose">
                    <div class="mint-cell-wrapper">
                        <div class="mint-cell-title">
                            <span class="mint-cell-text">盖章顺序</span>
                        </div>
                        <div class="mint-cell-value" @click="showSealIndexPup">
                            <mt-field readonly v-model="sealIndexName" ></mt-field>
                        </div>
                    </div>
                    <mt-popup v-model="popupSealIndexVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom" style="width: 100%">
                        <mt-picker :slots="sealIndexList" value-key="label" @change="onSealIndexValuesChange" style="width: 100%" showToolbar>
                            <div class="picker-toolbar-title">
                                <div class="mint-datetime-action mint-datetime-cancel" @click="popupSealIndexVisible = !popupSealIndexVisible">
                                    关闭
                                </div>
                                <div class="mint-datetime-action mint-datetime-confirm" @click="confirmSealIndexSelect">
                                    确定
                                </div>
                            </div>
                        </mt-picker>
                    </mt-popup>
                </a>
                <mt-field label="合同份数" placeholder="如：2" v-model="request.contractCopies" onkeypress='return(/[\d]/.test(String.fromCharCode(event.keyCode)))'></mt-field>
                <mt-field v-if="startDateType=='1'" readonly label="合同开始日期" placeholder="请选择开始日期" v-model="request.startDate" @click.native="ShowPicker(1)"></mt-field>
                <mt-field v-if="startDateType=='0'" label="合同开始日期" placeholder="请输入开始日期" v-model="request.startDateDesc"></mt-field>
                <mt-radio v-if="request.signType=='10'"  title="选择日期/手动输入" v-model="startDateType" :options="StartDateOptions"></mt-radio>                
                <mt-field v-if="endDateType=='1'" readonly label="合同结束日期" placeholder="请选择结束日期" v-model="request.endDate" @click.native="ShowPicker(2)"></mt-field>
                <mt-field v-if="endDateType=='0'"  label="合同结束日期" placeholder="请输入结束日期" v-model="request.endDateDesc"></mt-field>
                <mt-radio v-if="request.signType=='10'"  title="选择日期/手动输入" v-model="endDateType" :options="EndDateOptions"></mt-radio>
                <mt-field readonly label="合同期（月）" placeholder="自动计算" v-model="contractPeriod"></mt-field> 

                <p>合同信息（项目简称+签署合同原因）</p>
                <mt-field placeholder="如：南京金桐石油化工FS-劳务外包" v-model="request.info" :attr="{ maxlength: 50 }" type="textarea" rows="1"></mt-field>
                <p>合同内容</p>
                <mt-field placeholder="描述合同的内容及签订的原因或变化的原因，最多300个字" :attr="{ maxlength: 300 }" v-model="request.contractContent" type="textarea" rows="3"></mt-field>
                
                <div v-if="request.signType!='10'" class='CurrentAmountWithTax_Create'>
                    <mt-radio
                        title="原合同金额类型："
                        v-model="request.curContractType"
                        :options="amountType"
                    ></mt-radio>
                    <mt-field
                        v-if="request.curContractType == 10"
                        label="原合同金额(含税) ￥"
                        v-model="request.currentAmount"
                        placeholder="请输入原合同金额"
                        type="number"
                    >元</mt-field>  
                    <mt-field
                        v-if="request.curContractType == 20"
                        label="原合同金额(含税) ￥"
                        v-model="request.currentAmount"
                        placeholder="请输入原合同金额"
                    ></mt-field>
                    <!-- <mt-field  label="原合同金额(含税) ￥" v-model="request.currentAmount" placeholder="请输入原合同金额"></mt-field> -->
                </div>
                <mt-radio v-if="request.signType!='10'" title="原合同金额年/月化" v-model="request.curContractAmountRate" :options="curContractAmountRateOptions"></mt-radio>
                <div class='CurrentAmountWithTax_Create'>
                    <mt-radio
                        title="新合同金额类型："
                        v-model="request.newContractType"
                        :options="amountType"
                    ></mt-radio>
                    <mt-field
                        v-if="request.newContractType == 10"
                        label="新合同金额(含税) ￥"
                        v-model="request.newAmount"
                        placeholder="请输入新合同金额"
                        type="number"
                    >元</mt-field>
                    <mt-field
                        v-if="request.newContractType == 20"
                        label="新合同金额(含税) ￥"
                        v-model="request.newAmount"
                        placeholder="请输入新合同金额"
                    ></mt-field>
                    <!-- <mt-field label="新合同金额(含税) ￥" v-model="request.newAmount" placeholder="请输入新合同金额"></mt-field> -->
                </div>
                <mt-radio title="新合同金额年/月化" v-model="request.newContractAmountRate" :options="newContractAmountRateOptions"></mt-radio>
                <div class="NewAmountWithTax_Create" v-if="request.newContractAmountRate == 2">
                    <mt-field                           
                        label="新合同年化金额(含税) ￥"
                        v-model="request.newContractYearAmount"
                        placeholder="请输入新合同年化金额"
                        type="number"
                    >元</mt-field>
                    <span style="color:red">(不足一年按合同期填写。)</span>
                </div>
                <mt-field v-if="request.signType!='10'" label="原利润率" v-model="request.currentProfitMargin"  placeholder="请输入原利润率"></mt-field>
                <mt-field label="新利润率" v-model="request.newProfitMargin"  placeholder="请输入新利润率"></mt-field>
                <mt-radio v-if="request.signType != '10'" title="原付款周期" v-model="request.currentPaymentTerms" :options="PaymentOptions"></mt-radio>
                <mt-field v-if="request.signType != '10' && request.currentPaymentTerms == '30'" placeholder="请输入原付款周期" v-model="request.currentPaymentTermsOther" :attr="{ maxlength: 20 }"></mt-field>
                <mt-radio title="新付款周期" v-model="request.newPaymentTerms" :options="PaymentOptions"></mt-radio>
                <mt-field v-if="request.newPaymentTerms == '30'" placeholder="请输入新付款周期" v-model="request.newPaymentTermsOther" :attr="{ maxlength: 20 }"></mt-field>
                <mt-radio v-if="request.signType == '10'" title="是否添加到SCM系统(仅限新合同填写)" style="justify-content:center " v-model="request.addSCMStr" :options="AddSCMOptions"></mt-radio>
                <mt-field v-if="currentApproverStr" readonly label="当前处理人" v-model="currentApproverStr"></mt-field>
                <p>备注</p>
                <mt-field style="padding-bottom:20px" placeholder="请输入备注信息" :attr="{ maxlength: 300 }" v-model="request.remark" type="textarea" rows="3"></mt-field>
            </div>
            <mt-datetime-picker  @touchmove.native.stop.prevent v-model="defaultStartDate" ref="picker1" type="date" :startDate="new Date('2010-01-01')" :endDate="new Date('2077-12-31')" year-format="{value}年" month-format="{value}月" date-format="{value}日" @confirm="handleConfirm1"></mt-datetime-picker>
            <mt-datetime-picker  @touchmove.native.stop.prevent v-model="defaultEndDate" ref="picker2" type="date" :startDate="defaultStartDate" :endDate="new Date('2077-12-31')" year-format="{value}年" month-format="{value}月" date-format="{value}日" @confirm="handleConfirm2"></mt-datetime-picker>
        </div>
        <attach-upload :canUpload="true" :deletable="true" :maxLength="100" :value="request.attachmentList" :contractList="detail.contractList" :attachFileList="detail.attachFileList" :legalList="detail.legalList" :coeList="detail.coeList" :contractType="7" :signType="request.signType"></attach-upload>

        <div class="a_infor" :class="{open:approveOpen}">
            <p @click="approveOpen = !approveOpen" class="red">备注</p>
            <div class="box" style="padding-bottom: 20px; margin-top:10px">
                <mt-field placeholder="请输入..." v-model="approveRequest.approveRemark" :attr="{ maxlength: 200 }" type="textarea" rows="3"></mt-field>
                <ul class="buttons">
                    <li>
                        <mt-button type="default" @click="ConfirmEdit()">更新</mt-button>
                    </li>
                    <li>
                        <mt-button type="default" @click="GoBack()">返回</mt-button>
                    </li>
                </ul>
                <div class="clear"></div>
            </div>
        </div>
        <operation-log :list="detail.contractOperationLog"></operation-log>
    </div>
</div>
</template>

<script>
import ApplicantInfo from '@/components/ApplicantInfo.vue';
import AttachUpload from '@/components/AttachUpload.vue';
import ContractInfo from '@/components/gsjy_ContractInfo.vue';
import OperationLog from '@/components/OperationLog.vue';
import {
    Toast,
    Indicator,
    MessageBox
} from 'mint-ui';
export default {
    data() {
        return {
            displayCostCenter:"",
            currentApproverStr: "",
            isOpen: true,
            detail: {
                currentRole: 0,
                contractList: [],
                attachFileList: [],
                legalList: [],
                coeList: [],
                contractAttachment: [],
                contractOperationLog: []
            },
            approveOpen: true,
            defaultStartDate: new Date(),
            defaultEndDate: new Date(),
            isSubmmit: false,
            title: "",
            request: {
                userNo:"",
                userName:"",
                applicantNo:"",
                applicantName:"",
                costCode:"",                
                costName:"",
                lineCode:"",
                lineName:"",
                approveRemark: '',
                contractType: '',
                protocolType: '',
                approvalType: '',
                signType: "",
                startDate: "",
                startDateDesc:"",
                endDate: "",
                endDateDesc:"",
                info: "",
                contractContent: "",
                curContractType: "10",
                currentAmount: "",
                curContractAmountRate: "0",
                newContractType: "10",
                newAmount: "",
                newContractAmountRate: '',
                newContractYearAmount: "",
                currentPurchasingRebates: "",
                newPurchasingRebates: "",
                currentTaxRate: "",
                newTaxRate: "",
                currentPaymentTerms: "",
                currentPaymentTermsOther: "",
                newPaymentTerms: "",
                newPaymentTermsOther: "",
                addSCM: false,
                addSCMStr: "1",
                remark: "",
                isDraft: true,
                attachmentList: [],
                fiscalYear:'',
                quarter:'',
                district:'',
                serviceType:'',
                incrementTypeCode:'',
                incrementTypeDesc:'',
                decrementTypeCode:'',
                decrementTypeDesc:'',
                sealType:'',
                sealIndex:'', 
                contractCopies:0,
                currentProfitMargin:'',
                newProfitMargin:'',
                contractAmountRate:'',
            },
            approveRequest: {
                isArchive: false,
                isApprove: false,
                approveRemark: '',
                isJumpToLastTask: false
            },
            amountType:[{
                label: "固定金额",
                value: "10",
            },
            {
                label: "其他",
                value: "20",
            }],
            TypeOptions: [{
                    label: '服务协议(收入)',
                    value: "10"
                },
                {
                    label: '采购协议(支出)',
                    value: "20"
                },
                {
                    label:'其他(如：保密协议)',
                    value:"30"
                }
            ],
            SignedOptions: [{
                    label: '销售新合同',
                    value: "10"
                },
                {
                    label: '运作新合同',
                    value: "60"
                },
                {
                    label: '续签合同',
                    value: "20"
                },
                {
                    label: '补充协议',
                    value: "30"
                },
                {
                    label:'一次性合同',
                    value:"40"
                },
                {
                    label:'其他(如：保密协议)',
                    value:"50"                    
                }
            ],
            fiscalYearList:[{
                    values:[
                        {
                            index:0,
                            label:'2021年',
                            value:'2021年'
                        },
                        {
                            index:1,
                            label:'2022年',
                            value:'2022年'
                        },
                        {
                            index:2,
                            label:'2023年',
                            value:'2023年'
                        },
                        {
                            index:3,
                            label:'2024年',
                            value:'2024年'
                        },
                        {
                            label:'2025年',
                            value:'2025年'
                        },
                        {
                            label:'2026年',
                            value:'2026年'
                        },
                        {
                            label:'2027年',
                            value:'2027年'
                        },
                        {
                            label:'2028年',
                            value:'2028年'
                        },
                        {
                            label:'2029年',
                            value:'2029年'
                        },
                        {
                            label:'未选择',
                            value:'未选择'
                        },
                    ]
                }
            ],
            fiscalYearName:'请选择',
            popupFiscalYearVisible:false,
            fiscalYearTempSelectItem: [null, null],
            districtList:[{
                    values:[
                        {
                            label:'东区',
                            value:'东区'
                        },
                        {
                            label:'南区',
                            value:'南区'
                        },
                        {
                            label:'西区',
                            value:'西区'
                        },
                        {
                            label:'北区',
                            value:'北区'
                        },
                        {
                            label:'中区',
                            value:'中区'
                        }
                    ]
                }
            ],
            districtName:'请选择',
            popupDistrictVisible:false,
            districtTempSelectItem: [null, null],
            serviceTypeOptions:[
                {label:'管理费',value:'管理费'},
                {label:'自负盈亏',value:'自负盈亏'},
                {label:'混合',value:'混合'},
                {label:'劳务外包',value:'劳务外包'},
                {label:'自购合同',value:'自购合同'},
                {label:'代采合同',value:'代采合同'},  
                {label:'其他',value:'其他'},                
            ],
            serviceTypeCheckList:[],
            serviceTypeCheckOther:false,
            serviceTypeOtherDesc:'', 
            incrementList: [{
                    values:[]
                    }
            ],
            incrementName:'请选择',
            incrementTempSelectItem: [null, null],
            incrementPopupVisible: false, 
            decrementList: [{
                values:[]
                }
            ],
            decrementName:'请选择',
            decrementTempSelectItem: [null, null],
            decrementVisible:false,
            popupSealTypeVisible:false,
            sealTypeList:[{
                    values:[
                        {
                            index:0,
                            label:'总公司合同章',
                            value:"16"
                        },
                        {
                            index:1,
                            label:"北京分公司",
                            value:"22"
                        },
                        {
                            index:2,
                            label:"总公司公章",
                            value:"12"
                        },
                        {
                            index:3,
                            label:"金白领",
                            value:"30"
                        },
                        {
                            index:4,
                            label:"其他分公司",
                            value:"26"
                        },                        
                    ]
                }                
            ],
            sealTypeName:'请选择',
            tempSealTypeSelectItem:[null,null],
            popupSealIndexVisible:false,
            sealIndexList:[{
                    values:[
                        {
                            index:0,
                            label:'爱玛客先盖',
                            value:"10"
                        },
                        {
                            index:1,
                            label:"对方先盖",
                            value:"20"
                        },
                        {
                            index:2,
                            label:"其他",
                            value:"90"
                        },                     
                    ]
                }                
            ],
            sealIndexName:'请选择',
            tempSealIndexSelectItem:[null,null],
            startDateType:"1",
            StartDateOptions: [{
                    label: '选择日期',
                    value: "1"
                },
                {
                    label: '手工输入',
                    value: "0"
                }
            ],
            endDateType:"1",
            EndDateOptions: [{
                    label: '选择日期',
                    value: "1"
                },
                {
                    label: '手工输入',
                    value: "0"
                }
            ],
            PaymentOptions: [{
                    label: '月付',
                    value: "10"
                },
                {
                    label: '季付',
                    value: "20"
                },
                {
                    label: '其他',
                    value: "30"
                }
            ],
            AddSCMOptions: [{
                label: '是',
                value: "1"
            }, {
                label: '否',
                value: "0"
            }],
            curContractAmountRateOptions: [{
                label: '年化',
                value: "1"
            },
            {
                label: '月化',
                value: "2"
            }
            ],
            newContractAmountRateOptions: [{
                label: '年化',
                value: "1"
            },
            {
                label: '月化',
                value: "2"
            },
            {
                label: '其他',
                value: "3"
            }
            ],
        };
    },
    computed:{
        contractPeriod:{
            get:function(){
                var that=this;
                if(that.endDateType=='0' || that.startDateType=='0'){
                    return;
                }

                var result="自动计算";
                if(that.request.startDate==null || that.request.startDate=="" || that.request.endDate==null || that.request.endDate==""){
                    return result;
                }
                else{
                    var startDate=new Date(that.request.startDate);
                    var endDate=new Date(that.request.endDate);
                    
                    var year=endDate.getFullYear()-startDate.getFullYear();
                    var month=endDate.getMonth()-startDate.getMonth();
                    var day=endDate.getDate()-startDate.getDate();

                    result=year*12+month;
                    if(day>=25){
                        result=result+1;
                    }
                    else if(day>=14 && day<25){
                        result=result+0.5;
                    }
                    else if(day<=-14 && day>=-25)
                    {
                        result=result-0.5
                    }
                    else if(day<=-25){
                        result=result-1;
                    }
                    return result;
                }          
            },
            set:function(newValue){

            }
        }        
    },
    components: {
        'applicant-info': ApplicantInfo,
        'attach-upload': AttachUpload,
        'contract-info': ContractInfo,
        'operation-log': OperationLog
    },
    methods: {
        showFiscalYearPup(){
            var that=this;
            that.popupFiscalYearVisible=true;
        },
        onFiscalYearValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.fiscalYearTempSelectItem[0] = values[0];
            }
        },
        confirmFiscalYearSelect() {
            var that = this;
            that.popupFiscalYearVisible = false;
            that.request.fiscalYear = that.fiscalYearTempSelectItem[0].value;
            that.fiscalYearName=   that.fiscalYearTempSelectItem[0].label;    
        },
        showDistrictPup(){
            var that=this;
            that.popupDistrictVisible=true;
        },
        onDistrictValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.districtTempSelectItem[0] = values[0];
            }
        },
        confirmDistrictSelect() {
            var that = this;
            that.popupDistrictVisible = false;
            that.request.district = that.districtTempSelectItem[0].value;
            that.districtName=   that.districtTempSelectItem[0].label;    
        },
        showIncrementPup() {
            var that = this;
            that.incrementPopupVisible = true;
        },
        onIncrementValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.incrementTempSelectItem[0] = values[0];
            }
        },
        confirmIncrementSelect() {
            var that = this;
            that.incrementPopupVisible = false;
            that.request.incrementTypeCode = that.incrementTempSelectItem[0].classItem;
            that.request.incrementTypeDesc = that.incrementTempSelectItem[0].className;  
            that.incrementName=  that.request.incrementTypeDesc;         
        },
        showDecrementPup() {
            var that = this;
            that.decrementVisible = true;
        },
        onDecrementValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.districtTempSelectItem[0] = values[0];
            }
        },
        DecrementconfirmSelect() {
            var that = this;
            that.decrementVisible = false;
            that.request.decrementTypeCode = that.districtTempSelectItem[0].classItem;
            that.request.decrementTypeDesc = that.districtTempSelectItem[0].className;  
            that.decrementName=  that.request.decrementTypeDesc;         
        },
        showSealTypePup(){
            var that=this;
            that.popupSealTypeVisible=true;
        },
        onSealTypeValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.tempSealTypeSelectItem[0] = values[0];
            }
        },
        confirmSealTypeSelect() {
            var that = this;
            that.popupSealTypeVisible = false;
            that.request.sealType =that.tempSealTypeSelectItem[0].value;  
            that.sealTypeName=  that.tempSealTypeSelectItem[0].label;         
        },
        showSealIndexPup(){
            var that=this;
            that.popupSealIndexVisible=true;
        },
        onSealIndexValuesChange(picker, values) {
            var that = this;
            if (values && values[0]) {
                that.tempSealIndexSelectItem[0] = values[0];
            }
        },
        confirmSealIndexSelect() {
            var that = this;
            that.popupSealIndexVisible = false;
            that.request.sealIndex =that.tempSealIndexSelectItem[0].value;  
            that.sealIndexName=  that.tempSealIndexSelectItem[0].label;         
        },
        onSignTypeValueChange(){
            var that=this;
            if(that.request.signType=="10"){//是新合同
                
                //原合同金额设置为0
                that.request.currentAmount="0";
                //原利润率设置为0
                that.request.currentProfitMargin="0";
            }
        },
        ConfirmEdit() {
            var that = this;
            MessageBox.confirm('', {
                title: '提示',
                message: '确定要提交更新吗?',
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(action => {
                that.Edit();
            }).catch(error => {
                return;
            });
        },
        Edit() {
            var that = this;

            if (that.request.addSCMStr == '1') {
                that.request.addSCM = true;
            } else {
                that.request.addSCM = false;
            }

            if(!that.request.costCode){
                Toast("请选择成本中心");
                return;
            }

            if (!that.request.protocolType) {
                Toast("请选择协议类型");
                return;
            }            

            if (!that.request.signType) {
                Toast("请选择签订类型");
                return;
            }

            if(that.request.protocolType !== "10" && that.request.signType === "10"){
                Toast("协议类型为‘采购协议（支出）’或‘其他’不能选择‘销售新合同’，请改正");
                return;
            }

            if(!that.request.fiscalYear){
                Toast("请选择年度");
                return;
            }
            
            // if(!that.request.quarter){
            //     Toast("请选择季度");
            //     return;
            // }

            // if(!that.request.district){
            //     Toast("请选择区域");
            //     return ;
            // }

            if(that.serviceTypeCheckList!=null && that.serviceTypeCheckList.length>0){
                var flag=false;
                that.serviceTypeCheckList.forEach((item) => {
                    if (item =="其他" && (that.serviceTypeOtherDesc==null || that.serviceTypeOtherDesc=='')) {
                        flag=true;
                    }
                });

                if(flag){
                    Toast("请输入服务类型其他类型描述");
                    return;
                }
            }

            var jsonServiceType=[];
            that.serviceTypeCheckList.forEach((item)=>{
                var itemvalue=item;
                if(item=="其他"){
                    itemvalue=item+'|'+that.serviceTypeOtherDesc;
                }
                jsonServiceType.push(itemvalue);
            });
            that.request.serviceType=JSON.stringify(jsonServiceType); 

            if(!that.request.incrementTypeCode&&(!(that.request.protocolType=='20'&&that.request.signType=='10'))){
                Toast("请选择增长类型");
                return;
            }

            if(!that.request.decrementTypeCode&&(!(that.request.protocolType=='20'&&that.request.signType=='10'))){
                Toast("请选择减少类型");
                return;
            }

            if(!that.request.sealType){
                Toast("请选择用章类型");
                return;
            }

            if(!that.request.sealIndex){
                Toast("请选择盖章顺序");
                return;
            }

            if(!that.request.contractCopies){
                Toast("请输入合同份数");
                return;
            }

            if(typeof that.request.contractCopies !="number"){
                if(that.request.contractCopies%1!=0){
                    Toast("合同份数必须输入整数");
                return;
                }
            }

            //合同开始日期可以为空，这里设置一个固定值，后台处理未空
            if(that.request.signType=="10" && that.startDateType=='0'){
                that.request.startDate=new Date("2999-01-01");
                if(!that.request.startDateDesc){
                    Toast("请输入合同开始日期");
                    return;
                }
            }
            else{
                that.request.startDateDesc="";
                if(!that.request.startDate){
                    Toast("请选择合同开始日期");
                    return;
                }                
            }

            //合同结束日期可以为空，这里设置一个固定值，后台处理未空
            if(that.request.signType=="10" && that.endDateType=='0'){
                that.request.endDate=new Date("2999-01-01");
                if(!that.request.endDateDesc){
                    Toast("请输入合同截止日期");
                    return;
                }
            }
            else{
                that.request.endDateDesc="";
                if(!that.request.endDate){
                    Toast("请选择合同截止日期");
                    return;
                }  
            }

            if (!that.request.info) {
                Toast("请填写合同信息");
                return;
            }
            
            if (!that.request.contractContent) {
                Toast("请填写合同内容");
                return;
            }

            if(that.request.signType=="10"){
	            if(that.request.newPaymentTerms=="30" && that.request.newPaymentTermsOther==""){
                    //新签合同，新付款周期选择了其他，新付款周期的备注一定要填写
                    Toast("请填写自定义的新付款周期");
                    return;
                }                
            }
            else{
                if(that.request.currentPaymentTerms=="30" && that.request.currentPaymentTermsOther==""){
                    //续签合同或补充协议，当前付款周期选择其他，当前付款周期的备注一定要填写 
                    Toast("请填写自定义的原付款周期");  
                    return;                 
                }

                if(that.request.newPaymentTerms=="30" && that.request.newPaymentTermsOther==""){
                    //续签合同或补充协议，新付款周期选择其他，新付款周期的备注一定要填写
                    Toast("请填写自定义的新付款周期");
                    return;
                }
            }            

            if (that.request.newContractAmountRate == 0) {
                Toast("请选择新合同金额年化或月化");
                return;
            }

            if (!that.request.attachmentList || that.request.attachmentList.length == 0) {
                Toast("请上传合同附件");
                return;
            } else {
                var isHaveContractAttach = false;
                var isHaveLegal = false;
                var isHaveCOE = false;
                that.request.attachmentList.forEach((item) => {
                    if (item.type == 1) {
                        isHaveContractAttach = true;
                    }
                    if (item.type == 3) {
                        isHaveLegal = true;
                    }
                    if (item.type == 4) {
                        isHaveCOE = true;
                    }
                });

                if (!isHaveContractAttach) {
                    Toast("请上传合同附件");
                    return;
                }

                if (!isHaveLegal) {
                    Toast("请上传法务邮件审批");
                    return;
                }

                if (that.request.signType=="10"&&that.request.protocolType=="10"&&!isHaveCOE) {
                    //新合同必须上传测量报告
                    Toast("请上传测量报告");
                    return;
                }
            }            

            that.request.editRemark = that.approveRequest.approveRemark;

            if (that.isSubmmit) {
                return;
            }
            Indicator.open('提交中');
            that.isSubmmit = true;
            that.$axios
                .post("/api/Contract/LegalEditContract", that.request)
                .then((res) => {
                    Indicator.close();
                    that.isSubmmit = false;
                    if (res.data != null && res.data.isSuccess) {
                        MessageBox.alert('提交成功').then(action => {
                            that.$router.go(-1);
                        });
                    } else {
                        Toast({
                            message: res.data.message,
                            duration: 4000
                        });
                    }
                })
                .catch((err) => {
                    Indicator.close();
                    that.isSubmmit = false;
                    Toast("提交失败，请联系管理员");
                    console.log(err);
                });
        },
        GoBack() {
            var that = this;
            MessageBox.confirm('', {
                title: '提示',
                message: '确定要返回上一页吗?',
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(action => {
                that.$router.go(-1);
            }).catch(error => {
                return;
            });
        },
        getDateStr(date) {
            var d = new Date(date);
            var year = d.getFullYear();
            var month = (d.getMonth() + 1).toString();
            if (month.length == 1) {
                month = "0" + month;
            }
            var day = d.getDate().toString();
            if (day.length == 1) {
                day = "0" + day;
            }
            var hour = d.getHours().toString();
            if (hour.length == 1) {
                hour = "0" + hour;
            }
            var minute = d.getMinutes().toString();
            if (minute.length == 1) {
                minute = "0" + minute;
            }
            return `${year}-${month}-${day}`;
        },
        handleConfirm1(value) {
            var that = this;
            that.request.startDate = that.getDateStr(value);
        },
        handleConfirm2(value) {
            var that = this;
            that.request.endDate = that.getDateStr(value);
        },
        ShowPicker(index) {
            var that = this;
            if (index == 1) {
                that.defaultStartDate = new Date(that.request.startDate);
                that.$refs.picker1.open();
            } else {
                that.defaultEndDate = new Date(that.request.endDate);
                that.$refs.picker2.open();
            }
        },
        loadDetail() {
            var that = this;
            Indicator.open('数据加载中');
            that.$axios
                .get(`/api/Contract/GetDetail?businessKey=${that.request.businessKey}&type=${that.request.contractType}&taskId=${that.request.taskId}`)
                .then((res) => {
                    Indicator.close();
                    var result = res.data;
                    if (result != null && result.isSuccess) {
                        that.detail = result.data;
                        that.displayCostCenter=that.detail.costCenterCode+"-"+that.detail.costCenterName;
                        that.request.costCode=that.detail.costCenterCode;
                        that.request.costName=that.detail.costCenterName;
                        that.request.lineCode=that.detail.businessLineCode;
                        that.request.lineName=that.detail.businessLineName;
                        that.request.userNo=that.detail.submiterNo;
                        that.request.userName=that.detail.submiterName;
                        that.request.applicantNo=that.detail.applicantNo;
                        that.request.applicantName=that.detail.applicantName;

                        if (that.detail.currentRole != 2 && that.detail.currentRole != 3 && that.detail.currentRole!=10 && that.detail.currentRole!=100) {
                            that.$router.push({
                                path: `/pc_approve?businessKey=${that.request.businessKey}&type=${that.request.contractType}&taskId=${that.request.taskId}`
                            });
                            return;
                        }
                        that.detail.contractList = [];
                        that.detail.attachFileList = [];
                        that.detail.legalList = [];
                        that.detail.coeList = [];
                        that.detail.contractAttachment.forEach((item) => {
                            if (item.type == 1) {
                                that.detail.contractList.push(item);
                            } else if (item.type == 2) {
                                that.detail.attachFileList.push(item);
                            } else if (item.type == 3) {
                                that.detail.legalList.push(item);
                            } else if (item.type == 4) {
                                that.detail.coeList.push(item);
                            }
                        });

                        that.request.protocolType = result.data.protocolType + '';
                        that.request.approvalType = result.data.approvalType + '';
                        that.request.signType = result.data.signType + '';
                        that.request.startDate = result.data.startDateStr;
                        that.request.endDate = result.data.endDateStr;

                        that.request.info = result.data.info;
                        that.request.contractContent = result.data.contractContent;
                       that.request.curContractType = result.data.curContractType;
                        that.request.currentAmount = result.data.currentAmount;
                        that.request.curContractAmountRate = result.data.curContractAmountRate;
                        that.request.newContractType = result.data.newContractType;
                        that.request.newAmount = result.data.newAmount;
                        that.request.newContractAmountRate = result.data.newContractAmountRate;
                        that.request.newContractYearAmount = result.data.newContractYearAmount;
                        that.request.currentPurchasingRebates = result.data.currentPurchasingRebates;
                        that.request.newPurchasingRebates = result.data.newPurchasingRebates;
                        that.request.currentTaxRate = result.data.currentTaxRate;
                        that.request.newTaxRate = result.data.newTaxRate;
                        that.request.currentPaymentTerms = result.data.currentPaymentTerms + '';
                        that.request.currentPaymentTermsOther = result.data.currentPaymentTermsOther;
                        that.request.newPaymentTerms = result.data.newPaymentTerms + '';
                        that.request.newPaymentTermsOther = result.data.newPaymentTermsOther;
                        that.request.addSCM = result.data.addSCM;
                        that.request.addSCMStr = result.data.addSCM ? '1' : '0';
                        that.request.remark = result.data.remark;
                        that.request.attachmentList = result.data.contractAttachment;

                        that.request.fiscalYear=result.data.fiscalYear;
                        that.request.quarter=result.data.quarter;
                        that.request.district=result.data.district;
                        that.request.serviceType=result.data.serviceType;
                        
                        that.request.incrementTypeCode=result.data.incrementTypeCode;
                        that.request.incrementTypeDesc=result.data.incrementTypeDesc;
                        that.incrementName=that.request.incrementTypeDesc;
                        var incIndex=0;
                        that.incrementList[0].values.forEach((item)=>{
                            if(item.classItem==that.request.incrementTypeCode){
                                that.incrementList[0].defaultIndex=incIndex;
                            }
                            incIndex++;
                        });

                        that.request.decrementTypeCode=result.data.decrementTypeCode;
                        that.request.decrementTypeDesc=result.data.decrementTypeDesc;
                        that.decrementName=that.request.decrementTypeDesc;
                        var decIndex=0;
                        that.decrementList[0].values.forEach((item)=>{
                            if(item.classItem==that.request.decrementTypeCode){
                                that.decrementList[0].defaultIndex=decIndex;
                            }
                            decIndex++;
                        });

                        that.request.currentProfitMargin=result.data.currentProfitMargin;
                        that.request.newProfitMargin=result.data.newProfitMargin;
                        that.request.contractAmountRate=String(result.data.contractAmountRate);

                        if(that.detail.sealType=="16"){
                            that.request.sealType="16";
                            that.sealTypeName="总公司合同章";                               
                        }
                        else if(that.detail.sealType=="22"){
                            that.request.sealType="22";
                            that.sealTypeName="北京分公司";                              
                        }
                        else if(that.detail.sealType=="12"){
                            that.request.sealType="12";
                            that.sealTypeName="总公司公章";
                        }
                        else if(that.detail.sealType=="30"){
                            that.request.sealType="30";
                            that.sealTypeName="金白领";                              
                        }
                        else if(that.detail.sealType=="26"){
                            that.request.sealType="26";
                            that.sealTypeName="其他分公司";                              
                        }
                        that.sealTypeList[0].values.forEach((item)=>{
                            if(item.value==that.request.sealType){
                                that.sealTypeList[0].defaultIndex=item.index;
                            }
                        });

                        that.request.sealIndex=result.data.sealIndex+"";
                        that.sealIndexName=result.data.sealIndexName;
                        that.sealIndexList[0].values.forEach((item)=>{
                            if(item.value==that.request.sealIndex){
                                that.sealIndexList[0].defaultIndex=item.index;
                            }
                        });

                        that.request.contractCopies=result.data.contractCopies;

                        if(that.detail.startDate=="0001-01-01T00:00:00"||that.detail.startDate=='2999-01-01T00:00:00'){
                            that.request.startDate="";
                            that.detail.startDateStr="";
                        }

                        if(that.detail.signType=="10" && that.detail.startDateDesc){
                            that.request.startDate="";
                            that.startDateType="0";
                            that.request.startDateDesc=that.detail.startDateDesc;
                        }

                        if(that.detail.endDate=="0001-01-01T00:00:00"||that.detail.endDate=='2999-01-01T00:00:00'){
                            that.request.endDate="";
                            that.detail.endDateStr="";
                        }

                        if(that.detail.signType=="10" && that.detail.endDateDesc){
                            that.request.endDate="";
                            that.endDateType="0";
                            that.request.endDateDesc=that.detail.endDateDesc;
                        }

                        if(that.detail.serviceType!=null){
                            if( that.detail.serviceType.substring(0,1)=='[' 
                                && that.detail.serviceType.substring(that.detail.serviceType.length-1)==']'){
                                var jsonServiceTypeJson=JSON.parse(that.detail.serviceType);
                                if(jsonServiceTypeJson!=null && jsonServiceTypeJson.length){
                                    that.serviceTypeCheckList=[];                                    
                                    jsonServiceTypeJson.forEach((item)=>{
                                        if(item.indexOf("其他")==0){
                                            that.serviceTypeCheckList.push("其他");
                                            that.serviceTypeCheckOther=true;
                                            that.serviceTypeOtherDesc=item.substring(3);
                                        }
                                        else{
                                            that.serviceTypeCheckList.push(item);
                                        }
                                        
                                    });
                                }
                            }
                            else{
                                that.serviceTypeCheckList.push("其他");
                                that.serviceTypeCheckOther=true;
                                that.serviceTypeOtherDesc=that.detail.serviceType;
                            }
                        }

                        that.fiscalYearName= that.request.fiscalYear;
                        that.fiscalYearList[0].values.forEach((item)=>{
                            if(item.value==that.request.fiscalYear){
                                that.fiscalYearList[0].defaultIndex=item.index;
                            }
                        });

                        that.districtName=that.request.district;
                         that.districtList[0].values.forEach((item)=>{
                            if(item.value==that.request.district){
                                that.districtList[0].defaultIndex=item.index;
                            }
                        }); 

                        that.currentApproverStr = "";
                        if (result.data.currentApprover) {
                            var jsonObj = JSON.parse(result.data.currentApprover);
                            if (jsonObj && jsonObj.constructor == Array) {
                                jsonObj.forEach(item => {
                                    that.currentApproverStr += item.UserName;
                                });
                            } else if (jsonObj && jsonObj.constructor == Object) {
                                if (jsonObj.UserName) {
                                    that.currentApproverStr = jsonObj.UserName;
                                }
                            }
                        }

                        that.TypeOptions.forEach(item=>{
                            if(that.detail.protocolType==item.value){
                                that.detail.protocolTypeStr=item.label;
                            }
                        })
                        that.SignedOptions.forEach(item=>{
                            if(that.detail.signType==item.value){
                                that.detail.signTypeStr=item.label;
                            }
                        })
                        

                    } else {
                        Toast(result.message);
                    }
                })
                .catch((err) => {
                    Indicator.close();
                    Toast("数据加载失败，请稍后再试");
                    console.log(err);
                });
        },
        GetIncrementType(){
            var that = this;
            that.$axios.get(`/api/Common/GetAllIncrementType?code=FS_Contract_IncrementType`)
                .then((res) => {
                    if (res.data != null && res.data.isSuccess) {
                        if (res.data.data) {
                            res.data.data.forEach(item => {
                                that.incrementList[0].values.push(item);
                            });
                        }
                    }
                })
                .catch((err) => {
                    Toast("查询失败");
                    console.log(err);
                });
        },       
        GetDecrementType(){
            var that = this;
            that.$axios.get(`/api/Common/GetAllIncrementType?code=FS_Contract_DecrementType`)
                .then((res) => {
                    if (res.data != null && res.data.isSuccess) {
                        if (res.data.data) {
                            res.data.data.forEach(item => {
                                that.decrementList[0].values.push(item);
                            });
                        }
                    }
                })
                .catch((err) => {
                    Toast("查询失败");
                    console.log(err);
                });
        },
    },
    watch:{
        serviceTypeCheckList:function(newOne,oldOne){
            var that=this;
            if(newOne==null || newOne.length==0){
                that.serviceTypeCheckOther=false;
                that.serviceTypeOtherDesc='';
            }
            else{
                var flag=false;
                newOne.forEach(item => {
                    if(item=='其他'){
                        that.serviceTypeCheckOther=true;
                        flag=true;
                    }
                });
                if(!flag){
                    that.serviceTypeOtherDesc='';
                    that.serviceTypeCheckOther=false;
                }
            }
        }
    },
    created() {
        var that = this;
        that.request.contractType = "7";
        that.request.businessKey = that.$route.query.businessKey;
        that.request.taskId = that.$route.query.taskId;

        that.approveRequest.contractType = that.request.contractType;
        that.approveRequest.businessKey = that.$route.query.businessKey;
        that.approveRequest.taskId = that.$route.query.taskId;
        that.title = "餐饮业务线合同";
        that.GetIncrementType();
        that.GetDecrementType();
        that.loadDetail();
    },
    mounted() {
        var that = this;
    }
};
</script>
